export default {
	main: [
		{
			title: "$vuetify.layout.menu.community",
			icon: "$home",
			component: "Home",
		},
		{
			title: "$vuetify.layout.menu.blog",
			href: "/blog",
			icon: '$book-open',
			onlyMobile: true,
		},
		{
			title: '$vuetify.layout.menu.watch',
			href: "/home",
			icon: '$monitor',
			onlyMobile: true,

		},
		{
			title: "$vuetify.layout.menu.groups",
			icon: "$groups",
			component: "Groups"
		},
		{
			title: "$vuetify.layout.menu.taskList",
			icon: "$list",
			component: "Tasks",
		},
		{
			title: "$vuetify.layout.menu.notes",
			icon: "$file-edit",
			component: "Notes",
		},
		// {
		// 	title: "Leanovatica",
		// 	icon: "$company",
		// 	href: 'https://leanovatica.com'
		// },
	],
	quickMenu: [
		{
			title: "$vuetify.layout.menu.saved",
			icon: "$bookmark",
			component: "Saved",
		},
		{
			title: "$vuetify.layout.menu.problems",
			icon: "$help",
			component: "Problems",
		},
		{
			title: "$vuetify.layout.menu.polls",
			icon: "$chart-bar",
			component: "Polls",
		},
	],
	managerMenu: [
		{
			title: "$vuetify.layout.menu.abuses",
			icon: "$exclamation",
			component: "Abuses"
		}
	],
}
